// The Zustand store-reset registry (step 4). Hard rule (09 stack table): stores hold UI state ONLY,
// never server data, and EVERY store exposes reset() wired into switchBand(). Each store self-registers its
// reset here at creation; switchBand()/logout call resetAllStores(). At the platform stage there are no
// feature stores yet — this is the mechanism they plug into.
const resetters = new Set<() => void>();

/** Register a store's reset() so switchBand()/logout scorch it. Returns an unregister fn. */
export function registerStoreReset(reset: () => void): () => void {
  resetters.add(reset);
  return () => resetters.delete(reset);
}

/** Reset every registered Zustand store (part of the switchBand scorch + logout). */
export function resetAllStores(): void {
  for (const reset of resetters) reset();
}
